import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { SERVER_URL } from "../../api";
import { useGameTexts } from "../../hooks/useGameTexts";
import handGood from "../../assets/hand-good.png";
import handWrong from "../../assets/hand-wrong.png";
import logoMedical from "../../assets/logo-medical.png";
import { useLang } from "../../translations/i18n";
import { ROUTES } from "../../utils/constants";
import { getScenarioByScreen, handleNavigate } from "../../utils/helpers";
import { modalQuestionInfo } from "../../utils/logger";

function buildImageUrl(value) {
	if (!value || typeof value !== "string") return null;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}


function buildQuestionExplanation(instruction, citation) {
	return `<div class="txt-black text-center">
		<div class="txt-turquoise bold">
			${instruction}
		</div>
		<div class="mt-4">
			Escoge una opción para cada elemento. Tienes 3 intentos.
		</div>
		<div class="w-100 px-5">		
			<div class="d-flex align-items-center justify-content-between mt-5 px-5">
				<div class="w-50 text-left">Todas las opciones correctas en alguno de los 3 intentos: </div>
				<div class="bg-correct p-2" style="width: 150px;">
					<img width="25" src=${handGood} class="me-1" />
					<span class="bold">+50</span> puntos
				</div>
			</div>
			<div class="d-flex align-items-center justify-content-between mt-3 px-5">
				<div class="">En otro caso:</div>
				<div class="bg-incorrect p-2" style="width: 150px;">
					<img width="18" src=${handWrong} class="ms-1 me-2" />
					<span class="bold">0</span> puntos
				</div>
			</div>
		</div>
		<div class="mt-4 txt10">
			${citation}
		</div>
	</div>`;
}

function Scenario7Intro({ intl }) {
	const lang = useLang();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const group = useSelector((state) => state.group);
	const { texts, ready } = useGameTexts(group?.game);
	const [imageLoaded, setImageLoaded] = useState(false);

	const title = texts["scenario7-intro.title"] ?? "";
	const subtitle = texts["scenario7-intro.subtitle"] ?? "";
	const body = texts["scenario7-intro.body"] ?? "";
	const instruction = texts["scenario7-intro.instruction"] ?? "";
	const citation = texts["scenario7-intro.citation"] ?? "";
	const imageUrl = ready && (texts["scenario7-intro.image"] || texts["avatar.patient"])
		? buildImageUrl(texts["scenario7-intro.image"] || texts["avatar.patient"])
		: null;

	useEffect(() => {
		if (!imageUrl) {
			setImageLoaded(false);
			return;
		}
		setImageLoaded(false);
		const img = new Image();
		let cancelled = false;
		img.onload = () => { if (!cancelled) setImageLoaded(true); };
		img.onerror = () => { if (!cancelled) setImageLoaded(false); };
		img.src = imageUrl;
		return () => { cancelled = true; img.src = ""; };
	}, [imageUrl]);

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} />
				</div>
				<div
					style={{ paddingLeft: "6vh", paddingRight: "6vh", minHeight: "60vh" }}
					className="row d-flex justify-content-start align-items-start mt-5"
				>
					{!ready ? (
						<div className="col-6 txtWhite d-flex align-items-center">
							<div className="txtWhite">Cargando...</div>
						</div>
					) : (
					<>
					<div className="col-3 txtWhite">
						<div
							className="txtWhite txt20"
							style={{ letterSpacing: 3 }}
						>
							ESCENARIO 7
						</div>
						<div
							className="txtWhite txt30 bold mt-3"
							style={{ letterSpacing: 3, lineHeight: "35px" }}
							dangerouslySetInnerHTML={{ __html: title }}
						/>
						<div
							className="bold mt-4"
							style={{ lineHeight: "20px" }}
							dangerouslySetInnerHTML={{ __html: subtitle }}
						/>
					</div>
					<div className="col-3">
						{imageUrl && imageLoaded ? (
							<div className="patient-avatar-circle" style={{ width: 200, height: 200, background: "#e8e8e8" }}>
								<img
									src={imageUrl}
									alt=""
									style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
								/>
							</div>
						) : (
							<div className="patient-avatar-circle" style={{ width: 200, height: 200, background: "#e0e0e0" }} aria-hidden />
						)}
					</div>
					<div
						className="col-6 text-center txt-white txt18"
						dangerouslySetInnerHTML={{ __html: body }}
					/>
					<div
						className="container"
						style={{
							position: "absolute",
							right: "7vh",
							bottom: "4vh",
						}}
					>
						<div className="d-flex justify-content-end">
							<div
								className="btn-main me-3"
								onClick={() =>
									modalQuestionInfo({
										html: buildQuestionExplanation(instruction, citation),
									}).then((res) => {
										if (res.isConfirmed)
											handleNavigate({
												group: group,
												navigate: navigate,
												dispatch: dispatch,
												navigateTo: ROUTES.SCENARIO7,
												scenarioNum:
													getScenarioByScreen(
														ROUTES.SCENARIO7
													),
											});
									})
								}
							>
								<div className="txt-btn-main">AVANZAR</div>
							</div>
						</div>
					</div>
					</>
					)}
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario7Intro);
